module.exports = __webpack_public_path__ + "static/img/box-open.86200233.png";